<header _ngcontent-c0="">
  <div _ngcontent-c0="" class="fcta-header">
    <div _ngcontent-c0="" class="ui container fadeInDown">
      <a _ngcontent-c0="" class="launch icon item">
        <i _ngcontent-c0="" class="content icon" (click)="onClickBar()"></i>
        <div _ngcontent-c0="" class="app-drawer-backdrop" [ngClass]="{'hide-sidebar': showSidebar === false}">
          <div _ngcontent-c0="" class="ui menu inverted vertical app-drawer">
            <app-sidebar ngcontent-c0="" nghost-c2="" (closeBar)="closeSideBar($event)"></app-sidebar>
          </div>
        </div>
      </a>
      <span _ngcontent-c0="">
        <a _ngcontent-c0="" class="cac-logo">
          <img _ngcontent-c0="" src="assets/images/crp-lms-logo.png">
        </a>
        <nav _ngcontent-c0="" class="ui menu">
          <div class="right menu white">
            <!-- <a class="item" href="/complaint">Help</a> -->
            <a class="item" href="/faq">FAQs</a>
            <!-- <a class="item" href="/contact-us">Contact Us</a> -->
          </div>
        </nav>
      </span>
    </div>
  </div>

  <nav _ngcontent-c0="" app-top-menu="" class="ui top menu" _nghost-c1="">

    <ng-container *ngIf="isLoggedIn; else elseTemplate">

      <div _ngcontent-c1="" class="ui container" sui-dropdown-group="">


        <!-- <app-breadcrumb></app-breadcrumb> -->
        <!-- <a _ngcontent-c1="" class="item" [routerLink]="'/dashboard'"
        [ngClass]="{'active': activeLink=='/dashboard'}" *ngIf="portalUserRole === !'CAC_CRP_DATA_ENTRY_OFFICER'">
          Dashboard
        </a>
        <a _ngcontent-c1="" class="item" [routerLink]="'/company-registration/company-list'"
        [ngClass]="{'active': activeLink=='/company-registration/company-list'}" *ngIf="!!(portalUserRole === 'CAC_CRP_DATA_ENTRY_OFFICER')">
          Dashboard
        </a> -->

        <!-- <div _ngcontent-c1="" class="ui dropdown item " sui-dropdown-group="">
          <span _ngcontent-c1="" class="text">Name Reservation</span>
          <i _ngcontent-c1="" class="dropdown icon"></i>
          <div _ngcontent-c1="" class="menu">
            <a _ngcontent-c1="" class="item" [routerLink]="'/name-reservation/applications'"
              [ngClass]="{'active': activeLink=='/name-reservation/applications'}">
              My Reservations
            </a>
            <div _ngcontent-c1="" class="divider"></div>
            <a [routerLink]="'/name-reservation/new-application'" _ngcontent-c1="" class="item"
              [ngClass]="{'active': activeLink=='/name-reservation/new-application'}">
              New Name Reservation
            </a>
          </div>
        </div>
         -->

        <div _ngcontent-c1="" class="ui dropdown " sui-dropdown-group="">
          <span _ngcontent-c1="" class="text">

            <!-- <div _ngcontent-c1="" class="ui container" sui-dropdown-group="" style="color: white;"> -->
              <a _ngcontent-c1="" class="item"   *ngIf=DATA_ENTRY_OFFICER style="color:'white;'"  [routerLink]="'/dashboard'"[ngClass]="{'active': activeLink=='/dashboard'}" >Dashboard
              </a>
              <a _ngcontent-c1="" class="item"  *ngIf=NOT_DATA_ENTRY_OFFICER style="color:'white'" [routerLink]="'/company-registration/company-list'"[ngClass]="{'active': activeLink=='/company-registration/company-list'}" >Dashboard22
              </a>


            <!-- </div> -->




          <!--  <app-breadcrumb></app-breadcrumb> -->
          </span>
          <!-- <i _ngcontent-c1="" class="dropdown icon"></i> -->
          <!-- <div _ngcontent-c1="" class="menu">
            <a _ngcontent-c1="" class="item" [routerLink]="'/company-registration/applications'"
              [ngClass]="{'active': activeLink=='/company-registration/applications'}">
              My Registrations
            </a>
            <div _ngcontent-c1="" class="divider"></div>
            <a [routerLink]="'/company-registration/new-application'" _ngcontent-c1="" class="item"
              [ngClass]="{'active': activeLink=='/company-registration/new-application'}">
              New Registration
            </a>
          </div> -->
        </div>





        <div class="right menu">
          <div _ngcontent-c1="" class="right menu">

            <a _ngcontent-c1="" class="item" *ngIf=CREATE_ACCREDITED_AGENT style="color:'white;'"  [routerLink]="'/register/new'"[ngClass]="{'active': activeLink=='/company-registration/register/new'}" >
              {{ 'Create Accredited Agent' | uppercase}}
            </a>

            <a _ngcontent-c1="" class="item" *ngIf=DATA_ENTRY_OFFICER style="color:'white;'"  [routerLink]="'/dashboard'"[ngClass]="{'active': activeLink=='/company-registration/dashboard'}" >
              {{ currentUser.username | uppercase}}
            </a>
            <a _ngcontent-c1="" class="item" *ngIf=NOT_DATA_ENTRY_OFFICER  style="color:'white'" [routerLink]="'/company-registration/company-list'"[ngClass]="{'active': activeLink=='/company-registration/company-list'}" >
              {{ currentUser.username | uppercase}}
            </a>
            <a _ngcontent-c1="" class="item" (click)="logout()">
              <i class="sign in icon" _ngcontent-c1=""></i>Logout</a>
          </div>
        </div>

      </div>
    </ng-container>

    <ng-template #elseTemplate>
      <div _ngcontent-c1="" class="ui container" sui-dropdown-group="" *ngIf="!isLoggedIn">

        <div _ngcontent-c1="" class="right menu pull-right" sui-dropdown-group="">
          <div _ngcontent-c1="" class="right menu pull-right">
            <!-- <ul _ngcontent-c1="" class="item" style="font-weight: 700; margin-top: 10px;">DATA ENTRY APPLICATION</ul> -->
            <a _ngcontent-c1="" class="item" href="/login"><i _ngcontent-c1="" class="sign in icon"></i>Login</a>
          </div>
        </div>
      </div>
    </ng-template>
  </nav>


</header>
